// ─── Shared UI helpers used by all page components ───────────────────────────
// Font and color tokens come from src/theme/appTheme.js — edit there to restyle.
import { useTheme } from "../appContext";
import { FONT } from "../theme/appTheme";

export { useTheme };

// mono: used as a spread ({ ...mono, fontSize: N }) on any technical/code text
export const mono = { fontFamily: FONT.mono };

// heading: use for titles and labels that should use the display font
export const heading = { fontFamily: FONT.heading };

// sans: explicit sans-serif (for body copy inside components)
export const sans = { fontFamily: FONT.sans };

export function EqBox({ lines, color = "#5bc4e3" }) {
  const C = useTheme();
  return (
    <div style={{ background: C.eqBg, border: `1px solid ${C.eqBorder}`,
      borderRadius: 6, padding: "14px 18px", marginTop: 10, marginBottom: 10 }}>
      {lines.map((l, i) => (
        <div key={i} style={{ ...mono, fontSize: 11, lineHeight: 2,
          color: l.startsWith("//") || l === "" ? C.muted : color }}>{l || "\u00A0"}</div>
      ))}
    </div>
  );
}

export function Card({ children, color = "#0e9cc0", style = {} }) {
  const C = useTheme();
  return (
    <div style={{ background: C.panel, border: `1px solid ${color}22`,
      borderTop: `2px solid ${color}66`, borderRadius: 8,
      padding: 20, marginBottom: 14, ...style }}>{children}</div>
  );
}

export function Label({ children, color }) {
  const C = useTheme();
  return (
    <div style={{ ...mono, fontSize: 9, color: color || C.muted, letterSpacing: 3,
      textTransform: "uppercase", marginBottom: 8 }}>{children}</div>
  );
}

export function Stat({ label, value, unit, color = "#0e9cc0", sub }) {
  const C = useTheme();
  return (
    <div style={{ background: C.eqBg, border: `1px solid ${color}22`,
      borderRadius: 6, padding: "10px 12px" }}>
      <div style={{ ...mono, fontSize: 8, color: C.muted, letterSpacing: 2,
        marginBottom: 4 }}>{label}</div>
      <div style={{ ...mono, fontSize: 20, fontWeight: 700, color }}>
        {value}<span style={{ fontSize: 11, color: C.muted, marginLeft: 4 }}>{unit}</span>
      </div>
      {sub && <div style={{ ...mono, fontSize: 9, color: C.muted, marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export function Row({ label, a, b, ca = "#ef4444", cb = "#22c55e" }) {
  const C = useTheme();
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 130px",
      padding: "7px 0", borderBottom: `1px solid ${C.border}` }}>
      <div style={{ ...mono, fontSize: 10, color: C.text }}>{label}</div>
      <div style={{ ...mono, fontSize: 11, color: ca, textAlign: "right", fontWeight: 600 }}>{a}</div>
      <div style={{ ...mono, fontSize: 11, color: cb, textAlign: "right", fontWeight: 600 }}>{b}</div>
    </div>
  );
}

export function Btn({ children, active, color = "#0e9cc0", onClick }) {
  const C = useTheme();
  return (
    <button onClick={onClick} style={{ padding: "5px 12px", ...mono,
      fontSize: 9, letterSpacing: 1.5, cursor: "pointer",
      background: active ? `${color}20` : "transparent",
      border: `1px solid ${active ? color + "66" : C.border}`,
      color: active ? color : C.muted, borderRadius: 4,
      textTransform: "uppercase", transition: "all 0.1s" }}>{children}</button>
  );
}
